import classNames from 'classnames'
import toast from 'react-hot-toast'

type PropTypes = {
  variant?: string,
  title?: string,
  message: string,
  showCloseButton?: boolean,
}

const Toast = ({ variant = 'success', title, message, showCloseButton = false }: PropTypes) => {
  return (
    <div className="flex flex-col gap-1 relative">
      {showCloseButton && (
        <button
          onClick={() => toast.dismiss()}
          className="absolute top-0 right-0"
          aria-label="Close"
        >
          <span className="text-gray-500">✕</span>
        </button>
      )}
      <p className={classNames('text-sm font-semibold', {
        'text-success-700': variant === 'success',
        'text-error-600': variant === 'error',
      })}
      >
        {title}
      </p>
      <p className={classNames('text-sm', {
        'text-success-700': variant === 'success',
        'text-error-600': variant === 'error',
      })}
      >
        {message}
      </p>
    </div>
  )
}

export default Toast
